import { inject, Injectable } from '@angular/core';
import { WorkflowBaseService } from './base/workflow-base.service';
import { ReportCoreService } from './report-core.service';

@Injectable({
    providedIn: 'root',
})
/** Il servizio WorkflowService implementa le logiche client ed espone tutti i metodi del WorkflowBaseService
 * che mappa il controller REST Workflow 1:1.
 * */
export class WorkflowService extends WorkflowBaseService {
    private readonly reportCoreService = inject(ReportCoreService); // Attenzione alle dipendenze circolari

    constructor() {
        super();
    }
}
